const urlParser = document.createElement('a')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function prettyDate (date) {
  var a = new Date(date)
  return a.toDateString()
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}

export function deliveryName (type) {
  if (type === 0) {
    return '所有取餐方式'
  } else if (type === 1) {
    return '自取'
  } else if (type === 2) {
    return '內用'
  } else if (type === 3) {
    return '外送'
  } else if (type === 4) {
    return '外帶'
  } else if (type === 5) {
    return '吧台'
  } else if (type === 21) {
    return '內用-桌邊掃碼'
  } else {
    return '無資料'
  }
}

export function orderStatusName (state) {
  if (state === 0) {
    return '訂單尚未確認'
  } else if (state === 1) {
    return '訂單已送出，尚未付款'
  } else if (state === 2) {
    return '付款中'
  } else if (state === 3) {
    return '訂單已付款，尚未通知店家'
  } else if (state === 99) {
    return '客人取消'
  } else if (state === 100) {
    return '未接單'
  } else if (state === 110) {
    return '已接單'
  } else if (state === 120) {
    return '店家退訂'
  } else if (state === 121) {
    return '系統退訂'
  } else if (state === 122) {
    return '已取消'
  } else if (state === 130) {
    return '已完成'
  } else if (state === 140) {
    return '已作廢'
  }
}

export function shippingStatusName (state) {
  if (state === 100) {
    return '成立物流單'
  } else if (state === 110) {
    return '物流接單'
  } else if (state === 120) {
    return '已分派外送員'
  } else if (state === 130) {
    return '已取貨'
  } else if (state === 140) {
    return '已送達'
  } else if (state === 900) {
    return '門市取消叫件'
  } else if (state === 920) {
    return '媒合失敗'
  }
}

export function orderStateColor (state) {
  // 訂單狀態顏色
  switch (state) {
    case 140: // 已作廢
    case 120: // 被店家退訂
    case 121: // 被系統退訂
    case 122: // 已取消
    case 99: // 使用者取消訂單
      return 'label-danger'
    case 100: // 未接單
      return 'label-default'
    case 110: // 已接單
      return 'label-primary'
    case 130: // 已完成
      return 'label-success'
    default:
      return 'label-warning'
  }
}

export function shippingStateColor (state) {
  // 物流狀態顏色
  switch (state) {
    case 900: // 門市已取消叫件
    case 920: // 媒合失敗
      return 'label-danger'
    case 100: // 已確定叫件
      return 'label-default'
    case 110: // 已接受叫件
      return 'label-pink'
    case 120: // 已分派外送員
      return 'label-warning'
    case 130: // 已取貨
      return 'label-primary'
    case 140: // 已送達
      return 'label-success'
    default:
      return 'label-default'
  }
}

export function tradeName (type) {
  let name = ''
  switch (type) {
    case 1:
      name = '現金'
      break
    case 701:
      name = 'iPASS MONEY'
      break
    case 707:
      name = 'LINE PAY'
      break
    case 709:
      name = '信用卡(台新)'
      break
    case 706:
      name = '信用卡'
      break
    case 710:
      name = '信用卡'
      break
    case 713:
      name = '台灣Pay'
      break
    case 716:
      name = '全盈+PAY'
      break
    case 717:
      name = '悠遊付'
      break
    case 718:
      name = 'Pi 拍錢包'
      break
    case 719:
      name = '全支付'
      break
    case 720:
      name = 'icash Pay'
      break
    case 908:
      name = '街口支付'
      break
    case 909:
      name = '遠傳電信代收'
      break
    default:
      name = '其他'
      break
  }
  return name
}

export function cityCode (cityList) {
  if (!cityList || !cityList.length) return '不限制'
  const cityName = cityList.map(item => {
    return item.name
  })
  return cityName.join('、')
}

export function shippingVendorName (code) {
  // 物流廠商
  switch (code) {
    case 'glo':
      return '全球快遞'
    case 'mete-mix':
      return 'AI 混合自動派件'
    case 'mete-pg':
      return 'Pandago'
    case 'mete-ud':
      return 'Uber Direct'
    case 'mete-lm':
      return 'Lalamove'
    case 'mete-glo':
      return '全球快遞'
    case 'pandago':
      return 'Pandago'
    default:
      return '-'
  }
}

// 停賣管理-操作來源
export function disItemSrcType (type) {
  let name = ''
  switch (type) {
    case 1:
      name = 'ECMS'
      break
    case 2:
      name = 'POS'
      break
    case 3:
      name = '接單APP'
      break
    default:
      name = '其他'
      break
  }
  return name
}

// 停賣管理-操作功能(品牌)
export function disItemStatus (type) {
  let name = ''
  switch (type) {
    case 0:
      name = '多店解除停賣'
      break
    case 1:
      name = '多店停賣'
      break
    default:
      name = '其他'
      break
  }
  return name
}

// 停賣管理-操作功能(門市)
export function disItemActionType (type) {
  let name = ''
  switch (type) {
    case 0:
      name = '永久停賣'
      break
    case 2:
      name = '當日停賣'
      break
    default:
      name = '其他'
      break
  }
  return name
}



// WEBPACK FOOTER //
// ./src/filters/index.js